export const API = {
    CONTACT_FORM: 'https://agmutilnode.xyz/EmailHtml/incoming.php',
    CHECKOUT_FORM : 'https://agmarketingapp.cc/apicrm/encryptionApi.php'
}